import {Component, Prop, Vue} from 'vue-property-decorator';
import Cross from '../Icons/Cross.vue';
import Cart from '../Icons/Cart.vue';

@Component({
  components: {
    Cross,
    Cart,
  },
})
export default class Modal extends Vue {
  @Prop({type: Boolean, required: false, default: false}) disabled: boolean | undefined;
  @Prop({type: Boolean, required: false, default: false}) initialOpen: boolean | undefined;
  @Prop({type: String, required: false}) triggerClassList: string | undefined;
  @Prop({type: Boolean, required: false, default: false}) onlyHideOnCloseButton: boolean | undefined;
  private isModalVisible = false;

  mounted() {
    if (this.initialOpen) {
      this.showModal();
    }
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.checkIfClose);
    document.body.classList.remove('noScroll');
  }

  checkIfClose(e) {
    if (e.key === 'Escape') {
      this.closeModal();
    }
  }

  showModal() {
    this.isModalVisible = true;
    document.body.classList.add('noScroll');
    window.addEventListener('keydown', this.checkIfClose);
    this.$emit('open');
  }

  closeModal(isCloseButtonClick: boolean = false) {
    if (this.onlyHideOnCloseButton && !isCloseButtonClick) {
      return;
    }
    window.removeEventListener('keydown', this.checkIfClose);
    this.isModalVisible = false;
    document.body.classList.remove('noScroll');
    this.$emit('close');
  }

  get triggerButtonClassList() {
      return this.triggerClassList || 'button button--noButton';
  }
}
